import { render, staticRenderFns } from "./model-fix-dimensions.vue?vue&type=template&id=21aa1270&"
import script from "./model-fix-dimensions.vue?vue&type=script&lang=js&"
export * from "./model-fix-dimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21aa1270')) {
      api.createRecord('21aa1270', component.options)
    } else {
      api.reload('21aa1270', component.options)
    }
    module.hot.accept("./model-fix-dimensions.vue?vue&type=template&id=21aa1270&", function () {
      api.rerender('21aa1270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Model/Fix/ModelFixDimensionsComponent/model-fix-dimensions.vue"
export default component.exports